const initialState = {
    lang: "fr"
}

export default function reducerLang(state = initialState, action) {
    switch (action.type) {
        case "ENGLISH":
            return {
                lang: "en"
            };
        case "FRENCH":
            return {
                lang: "fr"
            };
        default:
            return state;
    }
}